import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { getStoredValue, setStoredValue } from "../_helpers/storagehelper";
import { getCurrentDate, getPastDate } from "../utils/formatTime";

const ManagementUserID = getStoredValue("user")?.ManagementUserID;

const FacilityID = getStoredValue("user")?.FacilityID;

const staffRequestList = {
  FacilityID: FacilityID,
  InmatesId: 0,
  InmateResidentID: "",
  PodID: 0,
  RequestFormTypeID: 0,
  UserFirstName: "",
  UserLastName: "",
  ActiveStatus: 2,
  CreatedStartDate: getPastDate(12),
  CreatedEndDate: getCurrentDate(1),
  ResponseStartDate: "",
  ResponseEndDate: "",
  ManagementUserID: ManagementUserID,
  IsCreatedByMGUser: 2,
  PageNo: 1,
  RowCountPerPage: 10,
  SortBy: "RequestCreateDate DESC",
  exportExcel: false,
  exportPDF: false,
};
const defenderSearchList = {
  pRequestAdminTypeID: 2,
  CreatedStartDate: getPastDate(12),
  CreatedEndDate: getCurrentDate(1),
  ActiveStatus: 2,
  ResponseStartDate: "",
  ResponseEndDate: "",
  PodID: 0,
  InmateID: 0,
  InmateResidentID: "",
  FirstName: "",
  LastName: "",
  FacilityID: FacilityID,
  pRequestFormTypeID: 0,
  ManagementUserID: ManagementUserID,
  PageNo: 1,
  RowCountPerPage: 10,
  SortBy: "RequestCreateDate DESC",
};
const messageToInmateSearchList = {
  facilityID: FacilityID,
  InmatesId: 0,
  InmateResidentID: "",
  PodID: 0,
  RequestFormTypeId: 0,
  ManagementUserID: ManagementUserID,
  UserFirstName: "",
  UserLastName: "",
  ActiveStatus: 2,
  CreateStartDate: "",
  CreateEndDate: "",
  RespondStartDate: "",
  RespondEndDate: "",
  PageNo: 1,
  SortBy: "RequestReSubmitDate DESC",
  RowCountPerPage: 10,
  exportExcel: false,
  exportPDF: false,
};
const privateConversationSearchList = {
  FacilityID: FacilityID,
  InmatesId: 0,
  InmateResidentID: "",
  PodID: 0,
  InmateFirstName: "",
  InmateLastName: "",
  RequestCurrentStatus: 2,
  RequestCreateStartDate: "",
  RequestCreateEndDate: "",
  RequestRespondStartDate: "",
  RequestRespondEndDate: "",
  managementUserID: ManagementUserID,
  PageNo: 1,
  RowCountPerPage: 10,
  SortBy: "RequestCreateDate DESC",
  exportExcel: false,
  exportPDF: false,
};

const messageToInmateRequestFormPayload = {
  folderPath: "",
  filename: "",
  file: "",
  requestForumThreadID: 0,
  facilityID: FacilityID,
  facilityCode: "",
  inmatesId: "",
  InmateID: "",
  managementUserID: ManagementUserID,
  postByMuUser: 1,
  postByInmate: 0,
  activeStatus: 0,
  podCode: "",
  pdFormPostBody: "",
  pdfAttachPath: "",
  postType: 1,
};

const requestFormInfoPayload = {
  folderPath: "",
  filename: "",
  file: "",
  fileSize: 0,
  fileType: "",
  requestForumThreadID: "",
  facilityID: FacilityID,
  facilityCode: "",
  inmatesId: "",
  managementUserID: ManagementUserID,
  activeStatus: 0,
  noticesTitle: "",
  pdfAttachPath: "",
  postType: 1,
};

const publicDefenderFormPayload = {
  folderPath: "",
  filename: "",
  file: "",
  pRequestFormTypeID: 0,
  facilityID: FacilityID,
  facilityCode: "",
  inmatesId: 0,
  managementUserID: ManagementUserID,
  postByInmate: 0,
  postByMuUser: 1,
  activeStatus: 0,
  pdFormPostBody: "",
  pdfAttachPath: "",
  postType: 1,
};

const publicDefenderRequestFormPayload = {
  pRequestFormTypeID: 0,
  facilityID: FacilityID,
  inmatesId: 0,
  managementUserID: ManagementUserID,
  postByInmate: 0,
  postByMuUser: 1,
  activeStatus: 0,
  pdFormPostBody: "",
  pdfAttachPath: "",
  postType: 1,
};
// create slice
const name = "staffRequest";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports
export const staffRequestAction = { ...slice.actions, ...extraActions };
export const staffRequestReducer = slice.reducer;

function createInitialState() {
  return {
    //staff request search
    staffRequestSearchList: staffRequestList,
    //staff request search for public defender
    staffRequestDefenderSearchList: defenderSearchList,
    //message to inmate search list
    messageToInmateSearchListData: messageToInmateSearchList,
    //private conversation search list
    privateConversationSearchListData: privateConversationSearchList,
    // initialize state from local storage to enable user to stay logged in
    messageToInmateRequestFormPayloadData: messageToInmateRequestFormPayload,
    requestFormInfoPayloadData: requestFormInfoPayload,
    publicDefenderFormPayloadData: publicDefenderFormPayload,
    publicDefenderRequestFormPayloadData: publicDefenderRequestFormPayload,
    requestReview: false,
    formTitleList: [],
    formTypeList: [],
    publicDefenderList: {},
    staffRequestList: {},
    staffRequestListFullData: {},
    PODList: [],
    //private conversation
    LoadFacilityAdminMURequestFormAccessResponse: {},
    LoadPrivateConversationRequestReviewAllListResponse: {},
    InsertRequestForumMGUserThreadResponse: {},
    CheckPrivateConversationRequestEnabledorNotResponse: [],
    LoadPrivateConversationRequestUnreadCountResponse: {},

    //staff request list otherthan defender review
    LoadRequestReviewAllListResponse: {},
    //defender review
    PublicDefenderRequestReviewListResponse: {},
    //message to inmate review
    LoadMGUserRequestReviewDataListResponse: {},

    privateConversationList: {},
    privateConvoAcceptRequestReponse: {},
    inmateMessageCount: {},

    formTitleForInmateMessageResponse: [],
    //initiate message to inmate
    initiateInmateMessageList: {},
    LoadInmateMGUserRequestForumResponse: {},
    submitMessageToInmateRequestFormInfoResponse: {},
    UpdateMURequestReadResponse: {},

    //forms
    /* visitor request form */
    visitorInfo: {},
    visitorFormDetails: [],
    visitorRequestFormUpdate: {
      typ_ReqVisitorInfoRespond: [],
      requestVisitorFormID: 0,
      facilityID: getStoredValue("commonFacilityCode"),
      createdBy: getStoredValue("user")?.ManagementUserID,
      inmateID: 0
    },

    /* legal request form */
    legalRequestFormAccess: {},
    legalRequestList: {},
    closeRequestResponse: {},

    /* admin remedy form */
    remedyRequestFormData: {},
    InitialremedyRequestFormData: {},
    formUpdateResponse: {},
    submitRemedyRequestFormResponse: {},
    GetManagementUserAccessPermissionResponse: [],

    /* request form */
    requestFormInfoResponse: {},
    loadInmateRequestFormList: {},
    updateRequestFormTypePopupdata: {},
    updateChangeRequestFormTypeData: {},
    submitRequestFormInfoResponse: {},

    /* create new */
    messageTypeList: [],
    messageTypeListForMessageToInmateList: [],
    GetInmateFullNameList: [],

    inmateList: [],
    newFormResponse: {},

    /* review */
    indexValue: 0,

    /* public defender */
    publicDefenderDetailsResponse: {},
    AssignResponse: {},
    selfAssignResponse: {},
    RequestPDAssignAcceptOrRejectResponse: {},
    crispFormDetailsResponse: {},
    reviewList: { loading: false, data: [] },
    startProcessingResponse: {},
    submitResponse: {},
    GetPublicDefenderUserDropDownResponse: [],
    LoadInmateRequestPublicDefenderThreadPostResponse: {},
    GetManagementUserInfoResponse: {},

    //download
    DownLoadFileResponse: {},
    error: null,
  };
}

function createReducers() {
  return {
    updateVisitorRequestFormData,
    updateGrievanceData,
    updateReviewStatus,
    updateInmateList,
    updateFullNameList,
    updateIndexValue,
    updatePODList,
    setStaffRequestSearchList,
    setpublicDefenderSearchList,
    setMessageToInmateSearchList,
    setPrivateConversationSeachList,
    updateMessageToInmateRequestFormPayload,
    updateRequestFormInfoPayloadData,
    updatePublicDefenderFormPayload,
    updatePublicDefenderRequestFormPayload,
    resetStaffRequestSearcList,
    resetPublicDefenderSearchList,
    resetMessageToInmateSearchList,
    resetPrivateConversationSearchList,
    resetMessageToInmateRequestFormPayloadData,
    resetPublicDefenderRequestFormPayload,
    resetRequestFormInfoPayloadData,
    resetPublicDefenderFormPayload,
    resetPublicDefenderGridData,
    resetAdminGridData,
    resetForm,
    setStaffRequestList
  };

  function resetStaffRequestSearcList(state, action) {
    // state.staffRequestSearchList = action.payload;
    state.staffRequestSearchList = staffRequestList;
  }

  function resetPublicDefenderSearchList(state, action) {
    // state.staffRequestDefenderSearchList = action.payload;
    state.staffRequestDefenderSearchList = defenderSearchList;
  }
  function resetMessageToInmateSearchList(state, action) {
    // state.messageToInmateSearchListData = action.payload;
    state.messageToInmateSearchListData = messageToInmateSearchList;
  }
  function resetPrivateConversationSearchList(state, action) {
    // state.privateConversationSearchListData = action.payload;
    state.privateConversationSearchListData = privateConversationSearchList;
  }

  function resetMessageToInmateRequestFormPayloadData(state, action) {
    state.messageToInmateRequestFormPayloadData =
      messageToInmateRequestFormPayload;
  }

  function resetPublicDefenderRequestFormPayload(state, action) {
    state.publicDefenderRequestFormPayloadData =
      publicDefenderRequestFormPayload;
  }

  function resetRequestFormInfoPayloadData(state, action) {
    state.requestFormInfoPayloadData = requestFormInfoPayload;
  }
  function resetPublicDefenderFormPayload(state, action) {
    state.publicDefenderFormPayloadData = publicDefenderFormPayload;
  }
  function resetPublicDefenderGridData(state, action) {
    state.publicDefenderList = {};
  }
  function resetAdminGridData(state, action) {
    state.staffRequestList = {};
  }

  function setMessageToInmateSearchList(state, action) {
    state.messageToInmateSearchListData = action.payload;
  }
  function setPrivateConversationSeachList(state, action) {
    state.privateConversationSearchListData = action.payload;
  }
  function setStaffRequestSearchList(state, action) {
    state.staffRequestSearchList = action.payload;
  }

  function setpublicDefenderSearchList(state, action) {
    state.staffRequestDefenderSearchList = action.payload;
  }
  function updateVisitorRequestFormData(state, action) {
    state.visitorRequestFormUpdate = action.payload;
  }

  function updateGrievanceData(state, action) {
    state.remedyRequestFormData = action.payload;
  }

  function updateReviewStatus(state, action) {
    state.requestReview = action.payload;
  }
  function updateMessageToInmateRequestFormPayload(state, action) {
    state.messageToInmateRequestFormPayloadData = action.payload;
  }
  function updateRequestFormInfoPayloadData(state, action) {
    state.requestFormInfoPayloadData = action.payload;
  }
  function updatePublicDefenderFormPayload(state, action) {
    state.publicDefenderFormPayloadData = action.payload;
  }
  function updatePublicDefenderRequestFormPayload(state, action) {
    state.publicDefenderRequestFormPayloadData = action.payload;
  }

  function updateInmateList(state, action) {
    state.inmateList = action.payload;
  }

  function updateFullNameList(state, action) {
    state.GetInmateFullNameList = action.payload;
  }

  function updateIndexValue(state, action) {
    state.indexValue = action.payload;
  }

  function updatePODList(state, action) {
    state.PODList = action.payload;
  }

  function setStaffRequestList(state, action) {
    state.staffRequestList = action.payload;
  }

  function resetForm(state, action) {
    state.formUpdateResponse = { IsSucceed: -5 };
    state.closeRequestResponse = { IsSucceed: 0 };
    state.submitRemedyRequestFormResponse = { IsSucceed: 0 };
    state.updateRequestFormTypePopupdata = { IsSucceed: -3 };
    state.updateChangeRequestFormTypeData = { IsSucceed: -2 };
    state.submitRequestFormInfoResponse = { IsSucceed: -6 };
    state.newFormResponse = { IsSucceed: -2 };
    state.startProcessingResponse = { IsSucceed: -4 };
    state.privateConvoAcceptRequestReponse = { IsSucceed: -4 };
    state.InsertRequestForumMGUserThreadResponse = { IsSucceed: -4 };
    state.AssignResponse = { IsSucceed: -5 };
    state.selfAssignResponse = { IsSucceed: -8 };
    state.submitMessageToInmateRequestFormInfoResponse = { IsSucceed: -5 };
    state.RequestPDAssignAcceptOrRejectResponse = { IsSucceed: -5 };
    state.PublicDefenderThreadRespondResponse = { IsSucceed: -6 };
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/StaffRequest`;
  const KisokbaseUrl = `${process.env.REACT_APP_API_URL}`;
  const commonFacilityCode = getStoredValue("commonFacilityCode");

  return {
    getFormTitle: getFormTitle(),
    getFormType: getFormType(),
    getPODList: getPODList(),
    getInmateMessageCount: getInmateMessageCount(),
    getPublicDefenderList: getPublicDefenderList(),
    loadRequestFormSearchList: loadRequestFormSearchList(),

    //initiate message to inmate
    getInitiateInmateMessageList: getInitiateInmateMessageList(),
    submitMessageToInmateRequestFormInfo:
      submitMessageToInmateRequestFormInfo(),
    UpdateMURequestRead: UpdateMURequestRead(),
    CheckPrivateConversationRequestEnabledorNot:
      CheckPrivateConversationRequestEnabledorNot(),
    LoadPrivateConversationRequestUnreadCount:
      LoadPrivateConversationRequestUnreadCount(),
    LoadFacilityAdminPCRequestPermission:
      LoadFacilityAdminPCRequestPermission(),
    LoadFacilityAdminPCRUnreadCount: LoadFacilityAdminPCRUnreadCount(),
    LoadInmateMGUserRequestForum: LoadInmateMGUserRequestForum(),
    LoadInmateMGUserRequestForumPost: LoadInmateMGUserRequestForumPost(),

    formTitleForInmateMessage: formTitleForInmateMessage(),
    //private conversation
    LoadFacilityAdminMURequestFormAccess:
      LoadFacilityAdminMURequestFormAccess(),
    LoadPrivateConversationRequestReviewAllList:
      LoadPrivateConversationRequestReviewAllList(),
    InsertRequestForumMGUserThread: InsertRequestForumMGUserThread(),

    //form
    getVisitorInformation: getVisitorInformation(),
    getVisitorDetails: getVisitorDetails(),
    updateVisitorRequestForm: updateVisitorRequestForm(),
    //legal request form
    getRequestFormAccess: getRequestFormAccess(),
    getLegalRequestList: getLegalRequestList(),
    closeRequest: closeRequest(),
    //admin remedy form
    getRemedyRequestFormData: getRemedyRequestFormData(),
    submitRemedyRequestForm: submitRemedyRequestForm(),
    GetManagementUserAccessPermission: GetManagementUserAccessPermission(),
    //request form
    getRequestFormInfo: getRequestFormInfo(),
    getFormTypeList: getFormTypeList(),
    loadInmateRequestForumThreadList: loadInmateRequestForumThreadList(),
    updateRequestFormTypePopup: updateRequestFormTypePopup(),
    updateChangeRequestFormType: updateChangeRequestFormType(),
    submitRequestFormInfo: submitRequestFormInfo(),
    //create new
    getMessageType: getMessageType(),
    getMessageTypeForMessageToInmate: getMessageTypeForMessageToInmate(),
    GetInmateFullNameWithID: GetInmateFullNameWithID(),

    getInmateList: getInmateList(),
    createStaffRequestForm: createStaffRequestForm(),
    //private conversation
    getPrivateConversationList: getPrivateConversationList(),
    privateConvoAcceptRequest: privateConvoAcceptRequest(),

    /* public defender details */
    publicDefenderDetails: publicDefenderDetails(),
    Assign: Assign(),
    selfAssign: selfAssign(),
    RequestPDAssignAcceptOrReject: RequestPDAssignAcceptOrReject(),
    getCrispFormDetails: getCrispFormDetails(),
    getReviewList: getReviewList(),
    startProcessing: startProcessing(),
    handleSubmit: handleSubmit(),
    GetPublicDefenderUserDropDown: GetPublicDefenderUserDropDown(),
    LoadInmateRequestPublicDefenderThreadPost:
      LoadInmateRequestPublicDefenderThreadPost(),
    GetManagementUserInfo: GetManagementUserInfo(),
    PublicDefenderThreadRespond: PublicDefenderThreadRespond(),

    //otherthan defender Review
    LoadRequestReviewAllList: LoadRequestReviewAllList(),

    //admin review
    PublicDefenderRequestReviewList: PublicDefenderRequestReviewList(),

    //message to inmate review
    LoadMGUserRequestReviewDataList: LoadMGUserRequestReviewDataList(),

    //download
    DownLoadFile: DownLoadFile(),

    loadSendEmailToDisciplinaryReportAppeals: loadSendEmailToDisciplinaryReportAppeals()
  };

  function getFormTitle() {
    const URL = `${process.env.REACT_APP_API_URL}/Common`;
    return createAsyncThunk(
      `${name}/formTitle`,
      async (data) =>
        await fetchWrapper.get(
          `${URL}/LoadManagementRequestFormDropDown?managementUserID=${data?.ManagementUserID}&facilityID=${data?.FacilityCode}`
        )
    );
  }

  function getFormType() {
    return createAsyncThunk(
      `${name}/formType`,
      async (data) =>
        await fetchWrapper.get(
          `${baseUrl}/GetManagementRequestFormTypeDropDown?mangementUserID=${data?.ManagementUserID}&facilityID=${data?.FacilityCode}`
        )
    );
  }

  //pod list
  function getPODList() {
    const URL = `${process.env.REACT_APP_API_URL}/Common`;
    return createAsyncThunk(
      `${name}/PODList`,
      async (facilityCode) =>
        await fetchWrapper.get(
          `${URL}/LoadPodDropDown?facilityID=${facilityCode}&SharedPod=2&activeStatus=1`
        )
    );
  }

  //inmate message count
  // function getInmateMessageCount() {
  //   return createAsyncThunk(
  //     `${name}/InmateMessageCount`,
  //     async (data) =>
  //       await fetchWrapper.get(
  //         `${baseUrl}/LoadMGUserRequestUnreadCount?managementUserId=${data?.ManagementUserID}&facilityId=${data?.FacilityCode ? data?.FacilityCode  : commonFacilityCode}`
  //       )
  //   );
  // }

  function getInmateMessageCount() {
    return createAsyncThunk(
      `${name}/InmateMessageCount`,
      async (data) => {

        const mgmtId = data?.ManagementUserID;
        const facId = data?.FacilityCode || commonFacilityCode;

        // Stop API call if values missing
        if (!mgmtId || !facId) {
          return;
        }

        const url = `${baseUrl}/LoadMGUserRequestUnreadCount?managementUserId=${mgmtId}&facilityId=${facId}`;

        return await fetchWrapper.get(url);
      }
    );
  }


  //request list for defender user
  function getPublicDefenderList() {
    return createAsyncThunk(
      `${name}/publicDefenderList`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadRequestPublicDefenderUserSearchList`,
          data
        )
    );
  }

  //request list for defender admin
  function loadRequestFormSearchList() {
    return createAsyncThunk(
      `${name}/staffRequestForAdmin`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/LoadRequestFormSearchList`, data)
    );
  }

  //initiate message to inmate list
  function getInitiateInmateMessageList() {
    return createAsyncThunk(
      `${name}/LoadMGUserRequestFormTypeSearchList`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadMGUserRequestFormTypeSearchList`,
          data
        )
    );
  }

  //initiate message to inmate list
  function submitMessageToInmateRequestFormInfo() {
    return createAsyncThunk(
      `${name}/submitMessageToInmateRequestFormInfo`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/RequestForumMGUserThread`, data)
    );
  }

  //UpdateMURequestRead
  // function UpdateMURequestRead() {
  //   return createAsyncThunk(
  //     `${name}/UpdateMURequestRead`,
  //     async (data) =>
  //       await fetchWrapper.post(`${baseUrl}/UpdateMURequestRead`, data)
  //   );
  // }

  function UpdateMURequestRead() {
    return createAsyncThunk(
      `${name}/UpdateMURequestRead`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/UpdateMURequestRead?requestID=${data.requestID}&requestFormTypeID=${data.requestFormTypeID}&facilityID=${data.facilityID}&createdBy=${data.createdBy}`
        )
    );
  }

  //private conversation hide and show
  function CheckPrivateConversationRequestEnabledorNot() {
    return createAsyncThunk(
      `${name}/CheckPrivateConversationRequestEnabledorNot`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/CheckPrivateConversationRequestEnabledorNot?userId=${data?.UserID}&facilityId=${data?.FacilityID}`
        )
    );
  }

  //Load PrivateConversation Request UnreadCount
  // function LoadPrivateConversationRequestUnreadCount() {
  //   return createAsyncThunk(
  //     `${name}/LoadPrivateConversationRequestUnreadCount`,
  //     async (data) =>
  //       await fetchWrapper.post(
  //         `${baseUrl}/LoadPrivateConversationRequestUnreadCount?managementUserId=${data?.ManagementUserID}&facilityId=${data?.FacilityID ? data?.FacilityID : commonFacilityCode }`
  //       )
  //   );
  // }

  function LoadPrivateConversationRequestUnreadCount() {
    return createAsyncThunk(
      `${name}/LoadPrivateConversationRequestUnreadCount`,
      async (data) => {

        const mgmtId = data?.ManagementUserID;
        const facId = data?.FacilityID || commonFacilityCode;

        // Stop API call if values missing
        if (!mgmtId || !facId) {
          return;
        }
        const url = `${baseUrl}/LoadPrivateConversationRequestUnreadCount?managementUserId=${mgmtId}&facilityId=${facId}`;
        return await fetchWrapper.post(url);
      }
    );
  }


  //Load Facility Admin PCRequest Permission
  function LoadFacilityAdminPCRequestPermission() {
    return createAsyncThunk(
      `${name}/LoadFacilityAdminPCRequestPermission`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadFacilityAdminPCRequestPermission?userId=${data?.ManagementUserID}&facilityId=${data?.FacilityID}`
        )
    );
  }

  //Load Facility Admin PCRU nreadCount
  function LoadFacilityAdminPCRUnreadCount() {
    return createAsyncThunk(
      `${name}/LoadFacilityAdminPCRUnreadCount`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadFacilityAdminPCRUnreadCount?userId=${data?.ManagementUserID}&facilityId=${data?.FacilityID}`
        )
    );
  }

  function LoadInmateMGUserRequestForum() {
    return createAsyncThunk(
      `${name}/LoadInmateMGUserRequestForum`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadInmateMGUserRequestForum?requestForumThreadID=${data?.RequestFormTypeID}`
        )
    );
  }

  //Load Inmate MGUserRequestForum Post
  function LoadInmateMGUserRequestForumPost() {
    return createAsyncThunk(
      `${name}/LoadInmateMGUserRequestForumPost`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadInmateMGUserRequestForumPost?requestForumThreadID=${data?.RequestFormTypeID}&pageNo=${data?.pageNo}&rowCountPerPage=${data?.rowCountPerPage}`
        )
    );
  }

  //form Title For Inmate Message
  function formTitleForInmateMessage() {
    const URL = `${process.env.REACT_APP_API_URL}/Master`;
    return createAsyncThunk(
      `${name}/GetFacilityRequestFormType`,
      async (data) =>
        await fetchWrapper.get(
          `${URL}/GetFacilityRequestFormType?facilityId=${data?.FacilityID
          }&ActiveStatus=${1}`
        )
    );
  }

  /* visitor request form information */
  function getVisitorInformation() {
    return createAsyncThunk(
      `${name}/visitorInformation`,
      async (formID) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadInmateRequestVisitorForm?requestVisitorFormID=${formID}`
        )
    );
  }

  /* visitor request form details */
  function getVisitorDetails() {
    const URL = `${process.env.REACT_APP_API_URL}/ManagementUser/Inmate`;
    return createAsyncThunk(
      `${name}/VisitorFormDetails`,
      async (formID) =>
        await fetchWrapper.post(
          `${URL}/InmateRequestVisitorInfo?noticesId=${formID}`
        )
    );
  }

  /* Update visitor request form */
  function updateVisitorRequestForm() {
    return createAsyncThunk(
      `${name}/UpdateVisitorForm`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/UpdateRequestInmateVisitorRespond`,
          data
        )
    );
  }

  /* legal Request Form Access */
  function getRequestFormAccess() {
    return createAsyncThunk(
      `${name}/legalRequestFormAccess`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadValidateMURequestFormAccess?userId=${data?.ManagementUserID}&requestFormTypeID=${data?.formID}&facilityID=${data?.FacilityCode}`
        )
    );
  }

  /* Legal request form data */
  function getLegalRequestList() {
    return createAsyncThunk(
      `${name}/legalRequestList`,
      async (formID) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadInmateRequestIRRequestForm?requestVisitorFormID=${formID}`
        )
    );
  }

  /* Legal request form data */
  function closeRequest() {
    return createAsyncThunk(
      `${name}/closeRequest`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/UpdateInmateRequestIRRequestForm?iRRequestFormTypeID=${data?.formID}&userId=${data?.ManagementUserID}&inmateID=${data?.InmateID}`
        )
    );
  }

  /* remedy form data */
  function getRemedyRequestFormData() {
    return createAsyncThunk(
      `${name}/remedyRequestFormData`,
      async (id) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadInmateRequestAdminRemedy?requestAdminRemedyID=${id}`
        )
    );
  }
  /*submit remedy form data */
  function submitRemedyRequestForm() {
    return createAsyncThunk(
      `${name}/submitRemedyRequestForm`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/UpdateRequestAdminRemedyRespond`,
          data
        )
    );
  }

  /*submit remedy form data */

  function GetManagementUserAccessPermission() {
    const URL = `${process.env.REACT_APP_API_URL}/ManagementUser/User`;
    return createAsyncThunk(
      `${name}/GetManagementUserAccessPermission`,
      async (ManagementUser) => {
        return await fetchWrapper.get(
          `${URL}/GetManagementUserAccessPermission?ManagementUserID=${ManagementUser.ManagementUserID}&ManagementMenuID=${ManagementUser.ManagementMenuID}`
        );
      }
    );
  }

  /*request Form Info */
  function getRequestFormInfo() {
    return createAsyncThunk(
      `${name}/requestFormInfo`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadInmateRequestForumThread?formReqAccess=${data?.formID}&facilityId=${data?.FacilityCode}&inmatesId=${data?.InmateID}`
        )
    );
  }

  /*get Form Type List */
  function getFormTypeList() {
    return createAsyncThunk(
      `${name}/formTypeListDropDown`,
      async (data) =>
        await fetchWrapper.get(
          `${baseUrl}/GetManagementRequestFormChangeToDropDownList?facilityId=${data?.FacilityCode}&requestFormTypeID=${data?.formID}`
        )
    );
  }

  // Send Email for request form Type 2 
  function loadSendEmailToDisciplinaryReportAppeals() {
    return createAsyncThunk(
      `${name}/loadSendEmailToDisciplinaryReportAppeals`,
      async (objData) =>
        await fetchWrapper.post(`${KisokbaseUrl}/Kiosk/Requests/SendEmailToDisciplinaryReportAppeals?emailTo=${objData?.emailTo}&inmateName=${objData?.inmateName}&inmateId=${objData?.inmateId}&appealSubmissionDateTime=${objData?.appealSubmissionDateTime}&facilityName=${objData?.facilityName} `)
    )
  }

  /*load Inmate Request Forum ThreadList */
  function loadInmateRequestForumThreadList() {
    return createAsyncThunk(
      `${name}/loadInmateRequestForumThreadList`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadInmateRequestForumThreadList?formReqAccessId=${data?.formID}&pageNo=${data?.pageNo}&rowCountPerPage=${data?.rowCountPerPage}`
        )
    );
  }

  /*update RequestForm Type popup*/
  function updateRequestFormTypePopup() {
    return createAsyncThunk(
      `${name}/updateRequestFormTypePopup`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadChangeToFormTypeLimitStatus?facilityId=${data?.facilityCode}&requestFormTypeID=${data?.requestFormTypeID}&newRequestFormTypeId=${data?.newRequestFormTypeId}&inmateResidentId=${data?.inmateResidentId}`
        )
    );
  }

  /*update ChangeRequest Form Type*/
  function updateChangeRequestFormType() {
    return createAsyncThunk(
      `${name}/updateChangeRequestFormType`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/MoveForumFormToNewForum`, data)
    );
  }

  /*submit Request Form Info*/
  function submitRequestFormInfo() {
    return createAsyncThunk(
      `${name}/insertRequestForumThreadRespond`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/InsertRequestForumThreadRespond`,
          data
        )
    );
  }

  /*create new*/
  function getMessageType() {
    return createAsyncThunk(
      `${name}/getMessageType`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadZeroFrequencyLimitRequestFormTypeList?facilityId=${data?.FacilityCode}&userId=${data?.ManagementUserID}`
        )
    );
  }

  //getMessageType For MessageToInmate
  function getMessageTypeForMessageToInmate() {
    const URL = `${process.env.REACT_APP_API_URL}/Master`;
    return createAsyncThunk(
      `${name}/getMessageTypeForMessageToInmate`,
      async (data) =>
        await fetchWrapper.get(
          `${URL}/GetFacilityRequestFormType?facilityId=${data?.FacilityCode
          }&ActiveStatus=${1}`
        )
    );
  }

  //Get Inmate FullName With ID
  function GetInmateFullNameWithID() {
    const URL = `${process.env.REACT_APP_API_URL}/Master`;
    return createAsyncThunk(
      `${name}/GetInmateFullNameWithID`,
      async (data) =>
        await fetchWrapper.get(
          `${URL}/GetInmateFullNameWithID?facilityID=${data?.FacilityCode}`
        )
    );
  }

  /*inmate list*/
  function getInmateList() {
    return createAsyncThunk(
      `${name}/getInmateList`,
      async (data) =>
        await fetchWrapper.get(
          `${baseUrl}/GetInmateDropDown?facilityId=${data?.FacilityCode}&requestFormTypeId=${data?.formID}`
        )
    );
  }

  /*create Staff Request Form*/
  function createStaffRequestForm() {
    return createAsyncThunk(
      `${name}/createStaffRequestForm`,
      async (formData) =>
        await fetchWrapper.post(
          `${baseUrl}/InsertRequestForumThreadMGUser`,
          formData
        )
    );
  }

  /*public Defender Details*/
  function publicDefenderDetails() {
    return createAsyncThunk(
      `${name}/publicDefenderDetails`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadInmateRequestPublicDefenderMUPost?requestFormTypeID=${data?.formId}&managementUserId=${data?.ManagementUserID}&facilityId=${data?.FacilityCode}`
        )
    );
  }

  /*handle Assign*/
  function Assign() {
    return createAsyncThunk(
      `${name}/assign`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/RequestPublicDefenderAssignMU?pRequestFormTypeId=${data?.pRequestFormTypeId}&facilityId=${data?.facilityId}&createdBy=${data?.createdBy}&publicDefenderUserId=${data?.publicDefenderUserId}`
        )
    );
  }

  /* self Assign */
  function selfAssign() {
    return createAsyncThunk(
      `${name}/selfAssign`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/RequestPublicDefenderAssignMU?pRequestFormTypeId=${data?.pRequestFormTypeId}&facilityId=${data?.facilityId}&createdBy=${data?.createdBy}&publicDefenderUserId=${data?.publicDefenderUserId}`
        )
    );
  }

  /*Request PDAssign Accept Or Reject*/
  function RequestPDAssignAcceptOrReject() {
    return createAsyncThunk(
      `${name}/RequestPDAssignAcceptOrReject`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/RequestPDAssignAcceptOrReject`,
          data
        )
    );
  }

  /*get Crisp From Details*/
  function getCrispFormDetails() {
    return createAsyncThunk(
      `${name}/crispFormDetails`,
      async (formID) =>
        await fetchWrapper.get(
          `${baseUrl}/LoadPublicDefenderServicesInfo?requestVisitorInfoId=${formID}`
        )
    );
  }

  /*getReviewList*/
  function getReviewList() {
    return createAsyncThunk(
      `${name}/getReviewList`,
      async (formID) =>
        await fetchWrapper.get(
          `${baseUrl}/GetInmateRequestPdsNotesDetailsInfo?pDSRequestFormTypeID=${formID}`
        )
    );
  }

  /*startProcessing*/
  function startProcessing() {
    return createAsyncThunk(
      `${name}/startProcessing`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/RequestPDServicesAcceptOrReject`,
          data
        )
    );
  }

  /*handleSubmit*/
  function handleSubmit() {
    return createAsyncThunk(
      `${name}/handleSubmit`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/InsertPublicDefenderServices`, data)
    );
  }
  /*GetPublicDefenderUserDropDown*/
  function GetPublicDefenderUserDropDown() {
    return createAsyncThunk(
      `${name}/GetPublicDefenderUserDropDown`,
      async (data) =>
        await fetchWrapper.get(
          `${baseUrl}/GetPublicDefenderUserDropDown?facilityId=${data?.facilityId}`
        )
    );
  }

  /*LoadInmateRequestPublicDefenderThreadPost*/
  function LoadInmateRequestPublicDefenderThreadPost() {
    return createAsyncThunk(
      `${name}/LoadInmateRequestPublicDefenderThreadPost`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadInmateRequestPublicDefenderThreadPost?noticesId=${data?.noticesId}&isInmate=${data?.isInmate}&isMGUser=${data?.isMGUser}&managementUserID=${data?.managementUserID}&RowCountPerPage=${data?.RowCountPerPage}&pageNo=${data?.PageNo}`
        )
    );
  }
  /*GetManagementUserInfo*/
  function GetManagementUserInfo() {
    const URL = `${process.env.REACT_APP_API_URL}/ManagementUser/User`;
    return createAsyncThunk(
      `${name}/GetManagementUserInfo`,
      async (data) =>
        await fetchWrapper.get(
          `${URL}/GetPuDefManagementUserDetailsAsync?ManagementUserID=${data?.ManagementUserID}`
        )
    );
  }
  /*PublicDefenderThreadRespond*/
  function PublicDefenderThreadRespond() {
    return createAsyncThunk(
      `${name}/PublicDefenderThreadRespond`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/PublicDefenderThreadRespond`, data)
    );
  }

  /*LoadRequestReviewAllList*/
  function LoadRequestReviewAllList() {
    return createAsyncThunk(
      `${name}/LoadRequestReviewAllList`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/LoadRequestReviewAllList`, data)
    );
  }
  /*PublicDefenderRequestReviewList*/
  function PublicDefenderRequestReviewList() {
    return createAsyncThunk(
      `${name}/PublicDefenderRequestReviewList`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/PublicDefenderRequestReviewList`,
          data
        )
    );
  }
  /*LoadMGUserRequestReviewDataList*/
  function LoadMGUserRequestReviewDataList() {
    return createAsyncThunk(
      `${name}/LoadMGUserRequestReviewDataList`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadMGUserRequestReviewDataList`,
          data
        )
    );
  }

  /*DownLoadFile*/
  function DownLoadFile() {
    return createAsyncThunk(
      `${name}/DownLoadFile`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/DownloadFileFromPath?folderPath=${data?.folderPath}&filename=${data?.filename}`
        )
    );
  }

  //private conversation list
  function getPrivateConversationList() {
    return createAsyncThunk(
      `${name}/privateConversationList`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadPrivateConversationRequestFormList`,
          data
        )
    );
  }

  //private Convo Accept Request
  function privateConvoAcceptRequest() {
    return createAsyncThunk(
      `${name}/privateConvoAcceptRequest`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/UpdatePCRequestAcceptDetails?requestFormTreadId=${data?.RequestFormTypeID}&acceptedBy=${data?.ManagementUserID}`
        )
    );
  }

  //Load Facility Admin MURequest FormAccess
  function LoadFacilityAdminMURequestFormAccess() {
    return createAsyncThunk(
      `${name}/LoadFacilityAdminMURequestFormAccess`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadFacilityAdminMURequestFormAccess?userId=${data?.ManagementUserID}&requestFormTypeID=${data?.RequestFormType}`
        )
    );
  }

  //Load PrivateConversation RequestReview All
  function LoadPrivateConversationRequestReviewAllList() {
    return createAsyncThunk(
      `${name}/LoadPrivateConversationRequestReviewAllList`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/LoadPrivateConversationRequestReviewAllList`,
          data
        )
    );
  }

  //Insert Request Forum MGUserThread
  function InsertRequestForumMGUserThread() {
    return createAsyncThunk(
      `${name}/InsertRequestForumMGUserThread`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/InsertRequestForumMGUserThread`,
          data
        )
    );
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(extraActions.getFormTitle.pending, (state, action) => {
      let params = action.meta.arg;
      if (params?.isNoLoading) {
        state.loading = false;
      }
      else {
        state.loading = true;
      }
      state.error = null;
    })
    .addCase(extraActions.getFormTitle.fulfilled, (state, action) => {
      state.loading = false;
      state.formTitleList = action.payload;
    })
    .addCase(extraActions.getFormTitle.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //form type
    .addCase(extraActions.getFormType.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getFormType.fulfilled, (state, action) => {
      state.loading = false;
      state.formTypeList = action.payload;
    })
    .addCase(extraActions.getFormType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //POd Drop down
    // .addCase(extraActions.getPODList.pending, (state) => {
    //   state.loading = true;
    //   state.error = null;
    // })
    // .addCase(extraActions.getPODList.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.PODList = action.payload;
    // })
    // .addCase(extraActions.getPODList.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.error;
    // })

    //getInmateMessageCount
    .addCase(extraActions.getInmateMessageCount.pending, (state, action) => {
      let params = action.meta.arg;
      if (params?.isNoLoading) {
        state.loading = false;
      }
      else {
        state.loading = true;
      }
      state.error = null;
    })
    .addCase(extraActions.getInmateMessageCount.fulfilled, (state, action) => {
      state.loading = false;
      state.inmateMessageCount = action.payload;
      setStoredValue(
        "inmateMessageCount",
        action.payload?.RequestUnReadCount || 0
      );
    })
    .addCase(extraActions.getInmateMessageCount.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //get defender list
    .addCase(extraActions.getPublicDefenderList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getPublicDefenderList.fulfilled, (state, action) => {
      state.loading = false;
      const params = action.meta.arg;
      if (params?.isReviewData || params?.exportExcel) {
        state.publicDefenderListFullData = action?.payload;
      } else {
        state.publicDefenderList = action.payload;
      }
      // state.publicDefenderList = action.payload;
    })
    .addCase(extraActions.getPublicDefenderList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //staff request list for admin
    .addCase(extraActions.loadRequestFormSearchList.pending, (state, action) => {
      let params = action.meta.arg;
      if (params?.isNoLoading) {
        state.loading = false;
      }
      else {
        state.loading = true;
      }
      state.error = null;
    })
    .addCase(
      extraActions.loadRequestFormSearchList.fulfilled,
      (state, action) => {
        state.loading = false;
        const params = action.meta.arg;
        if (params?.isReviewData || params?.exportExcel) {
          state.staffRequestListFullData = action?.payload;
        } else {
          state.staffRequestList = action.payload;
        }
      }
    )
    .addCase(
      extraActions.loadRequestFormSearchList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //initiate message to inmate list
    .addCase(extraActions.getInitiateInmateMessageList.pending, (state, action) => {
      let params = action.meta.arg;
      if (params?.isNoLoading) {
        state.loading = false;
      }
      else {
        state.loading = true;
      }
      state.error = null;
    })
    .addCase(
      extraActions.getInitiateInmateMessageList.fulfilled,
      (state, action) => {
        state.loading = false;
        const params = action.meta.arg;
        if (params?.isReviewData || params?.exportExcel) {
          state.initiateInmateMessageListFullData = action?.payload;
        } else {
          state.initiateInmateMessageList = action.payload;
        }
        // state.initiateInmateMessageList = action.payload;
      }
    )
    .addCase(
      extraActions.getInitiateInmateMessageList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //private conversation hide and show
    .addCase(
      extraActions.CheckPrivateConversationRequestEnabledorNot.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.CheckPrivateConversationRequestEnabledorNot.fulfilled,
      (state, action) => {
        state.loading = false;
        state.CheckPrivateConversationRequestEnabledorNotResponse =
          action.payload;
      }
    )
    .addCase(
      extraActions.CheckPrivateConversationRequestEnabledorNot.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //Load Private Conversation Request UnreadCount
    .addCase(
      extraActions.LoadPrivateConversationRequestUnreadCount.pending,
      (state, action) => {
        let params = action.meta.arg;
        if (params?.isNoLoading) {
          state.loading = false;
        }
        else {
          state.loading = true;
        }
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadPrivateConversationRequestUnreadCount.fulfilled,
      (state, action) => {
        state.loading = false;
        state.LoadPrivateConversationRequestUnreadCountResponse =
          action.payload;
      }
    )
    .addCase(
      extraActions.LoadPrivateConversationRequestUnreadCount.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //private conversation list
    .addCase(extraActions.getPrivateConversationList.pending, (state, action) => {
      let params = action.meta.arg;
      if (params?.isNoLoading) {
        state.loading = false;
      }
      else {
        state.loading = true;
      }
      state.error = null;
    })
    .addCase(
      extraActions.getPrivateConversationList.fulfilled,
      (state, action) => {
        state.loading = false;
        const params = action.meta.arg;
        if (params?.exportExcel) {
          state.privateConversationListFullData = action?.payload;
        } else {
          state.privateConversationList = action.payload;
        }
      }
    )
    .addCase(
      extraActions.getPrivateConversationList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //privateConvoAcceptRequest
    .addCase(extraActions.privateConvoAcceptRequest.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.privateConvoAcceptRequest.fulfilled,
      (state, action) => {
        state.loading = false;
        const params = action.meta.arg;
        if (params?.exportExcel) {
          state.privateConvoAcceptRequestFullData = action?.payload;
        } else {
          state.privateConvoAcceptRequestReponse = action.payload;
        }
      }
    )
    .addCase(
      extraActions.privateConvoAcceptRequest.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //visitor request form information
    .addCase(extraActions.getVisitorInformation.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getVisitorInformation.fulfilled, (state, action) => {
      state.loading = false;
      state.visitorInfo = action?.payload;
    })
    .addCase(extraActions.getVisitorInformation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //visitor request form details
    .addCase(extraActions.getVisitorDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getVisitorDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.visitorFormDetails = action?.payload;
    })
    .addCase(extraActions.getVisitorDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //update visitor request form
    .addCase(extraActions.updateVisitorRequestForm.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.updateVisitorRequestForm.fulfilled,
      (state, action) => {
        state.loading = false;
        state.formUpdateResponse = action?.payload;
      }
    )
    .addCase(
      extraActions.updateVisitorRequestForm.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //legal request form access
    .addCase(extraActions.getRequestFormAccess.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getRequestFormAccess.fulfilled, (state, action) => {
      state.loading = false;
      state.legalRequestFormAccess = action?.payload;
    })
    .addCase(extraActions.getRequestFormAccess.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //legal request List
    .addCase(extraActions.getLegalRequestList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getLegalRequestList.fulfilled, (state, action) => {
      state.loading = false;
      state.legalRequestList = action?.payload;
    })
    .addCase(extraActions.getLegalRequestList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //close request
    .addCase(extraActions.closeRequest.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.closeRequest.fulfilled, (state, action) => {
      state.loading = false;
      state.closeRequestResponse = action?.payload;
    })
    .addCase(extraActions.closeRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //admin remedy form
    .addCase(extraActions.getRemedyRequestFormData.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.getRemedyRequestFormData.fulfilled,
      (state, action) => {
        state.loading = false;
        state.remedyRequestFormData = action?.payload;
        state.InitialremedyRequestFormData = action.payload;
      }
    )
    .addCase(
      extraActions.getRemedyRequestFormData.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //submit admin remedy form
    .addCase(extraActions.submitRemedyRequestForm.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.submitRemedyRequestForm.fulfilled,
      (state, action) => {
        state.loading = false;
        state.submitRemedyRequestFormResponse = action?.payload;
      }
    )
    .addCase(extraActions.submitRemedyRequestForm.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //GetManagement UserAccess Permission
    .addCase(
      extraActions.GetManagementUserAccessPermission.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.GetManagementUserAccessPermission.fulfilled,
      (state, action) => {
        state.loading = false;
        state.GetManagementUserAccessPermissionResponse = action?.payload;
      }
    )
    .addCase(
      extraActions.GetManagementUserAccessPermission.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //request form info
    .addCase(extraActions.getRequestFormInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getRequestFormInfo.fulfilled, (state, action) => {
      state.loading = false;
      state.requestFormInfoResponse = action?.payload;
    })
    .addCase(extraActions.getRequestFormInfo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //getFormTypeList
    .addCase(extraActions.getFormTypeList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getFormTypeList.fulfilled, (state, action) => {
      state.loading = false;
      state.formTypeListDropDown = action?.payload;
    })
    .addCase(extraActions.getFormTypeList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //loadInmateRequestForumThreadList
    .addCase(extraActions.loadInmateRequestForumThreadList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.loadInmateRequestForumThreadList.fulfilled,
      (state, action) => {
        state.loading = false;
        const params = action.meta.arg;
        // state.loadInmateRequestFormList = action?.payload;
        if (params?.exportExcel) {
          state.loadInmateRequestFormListFullData = action?.payload;
        } else {
          state.loadInmateRequestFormList = action.payload;
        }
      }
    )
    .addCase(
      extraActions.loadInmateRequestForumThreadList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //update RequestForm Typepopup
    .addCase(extraActions.updateRequestFormTypePopup.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.updateRequestFormTypePopup.fulfilled,
      (state, action) => {
        state.loading = false;
        state.updateRequestFormTypePopupdata = action?.payload;
      }
    )
    .addCase(
      extraActions.updateRequestFormTypePopup.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //update RequestForm Type
    .addCase(extraActions.updateChangeRequestFormType.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.updateChangeRequestFormType.fulfilled,
      (state, action) => {
        state.loading = false;
        state.updateChangeRequestFormTypeData = action?.payload;
      }
    )
    .addCase(
      extraActions.updateChangeRequestFormType.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //submitRequestFormInfo
    .addCase(extraActions.submitRequestFormInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.submitRequestFormInfo.fulfilled, (state, action) => {
      state.loading = false;
      state.submitRequestFormInfoResponse = action?.payload;
    })
    .addCase(extraActions.submitRequestFormInfo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //message type
    .addCase(extraActions.getMessageType.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getMessageType.fulfilled, (state, action) => {
      state.loading = false;
      state.messageTypeList = action?.payload;
    })
    .addCase(extraActions.getMessageType.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //getMessage Type For MessageToInmate
    .addCase(extraActions.getMessageTypeForMessageToInmate.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.getMessageTypeForMessageToInmate.fulfilled,
      (state, action) => {
        state.loading = false;
        state.messageTypeListForMessageToInmateList = action?.payload;
      }
    )
    .addCase(
      extraActions.getMessageTypeForMessageToInmate.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //Get Inmate FullName With ID
    .addCase(extraActions.GetInmateFullNameWithID.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.GetInmateFullNameWithID.fulfilled,
      (state, action) => {
        state.loading = false;
        state.GetInmateFullNameList = action?.payload;
      }
    )
    .addCase(extraActions.GetInmateFullNameWithID.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //inmate list
    .addCase(extraActions.getInmateList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getInmateList.fulfilled, (state, action) => {
      state.loading = false;
      state.inmateList = action?.payload;
    })
    .addCase(extraActions.getInmateList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //create new staff request form
    .addCase(extraActions.createStaffRequestForm.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.createStaffRequestForm.fulfilled, (state, action) => {
      state.loading = false;
      state.newFormResponse = action?.payload;
    })
    .addCase(extraActions.createStaffRequestForm.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //public Defender Details
    .addCase(extraActions.publicDefenderDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.publicDefenderDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.publicDefenderDetailsResponse = action?.payload;
    })
    .addCase(extraActions.publicDefenderDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //Assign
    .addCase(extraActions.Assign.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.Assign.fulfilled, (state, action) => {
      state.loading = false;
      state.AssignResponse = action?.payload;
    })
    .addCase(extraActions.Assign.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    //selfAssign
    .addCase(extraActions.selfAssign.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.selfAssign.fulfilled, (state, action) => {
      state.loading = false;
      state.selfAssignResponse = action?.payload;
    })
    .addCase(extraActions.selfAssign.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //Request PDAssign AcceptOrReject
    .addCase(extraActions.RequestPDAssignAcceptOrReject.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.RequestPDAssignAcceptOrReject.fulfilled,
      (state, action) => {
        state.loading = false;
        state.RequestPDAssignAcceptOrRejectResponse = action?.payload;
      }
    )
    .addCase(
      extraActions.RequestPDAssignAcceptOrReject.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //get Crisp Form Details
    .addCase(extraActions.getCrispFormDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getCrispFormDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.crispFormDetailsResponse = action?.payload;
    })
    .addCase(extraActions.getCrispFormDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //getReviewList
    .addCase(extraActions.getReviewList.pending, (state) => {
      state.reviewList.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getReviewList.fulfilled, (state, action) => {
      state.reviewList.loading = false;
      state.reviewList.data = action?.payload;
    })
    .addCase(extraActions.getReviewList.rejected, (state, action) => {
      state.reviewList.loading = false;
      state.error = action.error;
    })

    //startProcessing
    .addCase(extraActions.startProcessing.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.startProcessing.fulfilled, (state, action) => {
      state.loading = false;
      state.startProcessingResponse = action?.payload;
    })
    .addCase(extraActions.startProcessing.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //handle Submit
    .addCase(extraActions.handleSubmit.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.handleSubmit.fulfilled, (state, action) => {
      state.loading = false;
      state.submitResponse = action?.payload;
    })
    .addCase(extraActions.handleSubmit.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })
    //GetPublicDefenderUserDropDown
    .addCase(extraActions.GetPublicDefenderUserDropDown.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.GetPublicDefenderUserDropDown.fulfilled,
      (state, action) => {
        state.loading = false;
        state.GetPublicDefenderUserDropDownResponse = action?.payload;
      }
    )
    .addCase(
      extraActions.GetPublicDefenderUserDropDown.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //LoadInmateRequestPublicDefenderThreadPost
    .addCase(
      extraActions.LoadInmateRequestPublicDefenderThreadPost.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadInmateRequestPublicDefenderThreadPost.fulfilled,
      (state, action) => {
        state.loading = false;
        if (!action?.meta?.arg?.isExcelExport) {
          state.LoadInmateRequestPublicDefenderThreadPostResponse =
            action?.payload;
        }
      }
    )
    .addCase(
      extraActions.LoadInmateRequestPublicDefenderThreadPost.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //GetManagementUserInfo
    .addCase(extraActions.GetManagementUserInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetManagementUserInfo.fulfilled, (state, action) => {
      state.loading = false;
      state.GetManagementUserInfoResponse = action?.payload;
    })
    .addCase(extraActions.GetManagementUserInfo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //PublicDefenderThreadRespond
    .addCase(extraActions.PublicDefenderThreadRespond.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.PublicDefenderThreadRespond.fulfilled,
      (state, action) => {
        state.loading = false;
        state.PublicDefenderThreadRespondResponse = action?.payload;
      }
    )
    .addCase(
      extraActions.PublicDefenderThreadRespond.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //LoadRequestReviewAllList
    .addCase(extraActions.LoadRequestReviewAllList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadRequestReviewAllList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.LoadRequestReviewAllListResponse = action?.payload;
      }
    )
    .addCase(
      extraActions.LoadRequestReviewAllList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //PublicDefenderRequestReviewList
    .addCase(extraActions.PublicDefenderRequestReviewList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.PublicDefenderRequestReviewList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.PublicDefenderRequestReviewListResponse = action?.payload;
      }
    )
    .addCase(
      extraActions.PublicDefenderRequestReviewList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )
    //LoadMGUserRequestReviewDataList
    .addCase(extraActions.LoadMGUserRequestReviewDataList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadMGUserRequestReviewDataList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.LoadMGUserRequestReviewDataListResponse = action?.payload;
      }
    )
    .addCase(
      extraActions.LoadMGUserRequestReviewDataList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //handle Submit
    .addCase(extraActions.formTitleForInmateMessage.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.formTitleForInmateMessage.fulfilled,
      (state, action) => {
        state.loading = false;
        state.formTitleForInmateMessageResponse = action?.payload;
      }
    )
    .addCase(
      extraActions.formTitleForInmateMessage.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //Load Facility Admin MURequest FormAccess
    .addCase(
      extraActions.LoadFacilityAdminMURequestFormAccess.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadFacilityAdminMURequestFormAccess.fulfilled,
      (state, action) => {
        state.loading = false;
        state.LoadFacilityAdminMURequestFormAccessResponse = action?.payload;
      }
    )
    .addCase(
      extraActions.LoadFacilityAdminMURequestFormAccess.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //Load PrivateConversation RequestReview AllList
    .addCase(
      extraActions.LoadPrivateConversationRequestReviewAllList.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadPrivateConversationRequestReviewAllList.fulfilled,
      (state, action) => {
        state.loading = false;
        state.LoadPrivateConversationRequestReviewAllListResponse =
          action?.payload;
      }
    )
    .addCase(
      extraActions.LoadPrivateConversationRequestReviewAllList.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //Insert Request Forum MGUserThread
    .addCase(extraActions.InsertRequestForumMGUserThread.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.InsertRequestForumMGUserThread.fulfilled,
      (state, action) => {
        state.loading = false;
        state.InsertRequestForumMGUserThreadResponse = action?.payload;
      }
    )
    .addCase(
      extraActions.InsertRequestForumMGUserThread.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //Inmate MGUser RequestForum Thread
    .addCase(extraActions.LoadInmateMGUserRequestForum.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadInmateMGUserRequestForum.fulfilled,
      (state, action) => {
        state.loading = false;
        state.LoadInmateMGUserRequestForumResponse = action?.payload;
      }
    )
    .addCase(
      extraActions.LoadInmateMGUserRequestForum.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //Load Inmate MGUser Request ForumPost
    .addCase(extraActions.LoadInmateMGUserRequestForumPost.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      extraActions.LoadInmateMGUserRequestForumPost.fulfilled,
      (state, action) => {
        state.loading = false;
        if (!action?.meta?.arg?.isExcelExport) {
          state.LoadInmateMGUserRequestForumPostResonse = action?.payload;
        }
      }
    )
    .addCase(
      extraActions.LoadInmateMGUserRequestForumPost.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //submitMessageToInmateRequestFormInfo
    .addCase(
      extraActions.submitMessageToInmateRequestFormInfo.pending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    )
    .addCase(
      extraActions.submitMessageToInmateRequestFormInfo.fulfilled,
      (state, action) => {
        state.loading = false;
        state.submitMessageToInmateRequestFormInfoResponse = action?.payload;
      }
    )
    .addCase(
      extraActions.submitMessageToInmateRequestFormInfo.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    )

    //UpdateMURequestRead
    .addCase(extraActions.UpdateMURequestRead.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.UpdateMURequestRead.fulfilled, (state, action) => {
      state.loading = false;
      state.UpdateMURequestReadResponse = action?.payload;
    })
    .addCase(extraActions.UpdateMURequestRead.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    })

    //DownLoadFile
    .addCase(extraActions.DownLoadFile.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.DownLoadFile.fulfilled, (state, action) => {
      state.loading = false;
      state.DownLoadFileResponse = action?.payload;
    })
    .addCase(extraActions.DownLoadFile.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
}
